export default "__VITE_ASSET__BgP6XUAw__"